import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';

// ngrx store
import { Subscription } from 'rxjs';

// services
import { TooltipService } from '../../services/tooltip.service';

// models
import { TooltipData } from '../../models/tooltip.interface';


declare var Tether: any;

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit, OnDestroy {

  private _resizeWidth;
  private _resizeTimer;
  private _tooltipTimer;
  private _tooltipSelfCloseTimer;
  private _removeAllTooltipsSubscription: Subscription;
  private _tooltipID = 1;

  public tooltipData: TooltipData;
  public tooltipDataList: Array<any> = [];
  public tooltipObjList: Array<any> = [];

  constructor(
    private _tooltipService: TooltipService
  ) { }

  ngOnInit() {

    this._tooltipService.tooltipItem$
      .subscribe(tooltipItem => {
        if (tooltipItem === 'remove') {
          // this.closeTooltip();
          return;
        }

        // check if there is an active tooltip on the same target as the new one and remove it
        for (const item of this.tooltipDataList) {
          if (item.target === tooltipItem.target) {
            this.closeTooltip(item.id);
          }
        }

        tooltipItem.id = this._tooltipID;
        this._tooltipID = this._tooltipID + 1;

        this.create(tooltipItem);
    });

    this._removeAllTooltipsSubscription = this._tooltipService.removeAllTooltips$
      .subscribe(value => {
        clearTimeout(this._tooltipTimer);
        clearTimeout(this._tooltipSelfCloseTimer);
        this.closeAllTooltips();
      });
  }

  @HostListener('window:resize', ['$event', 'this.tooltipObjList', 'this.tooltipDataList', 'this.positonToolTip'])
  onResize(event, tooltipObjList, tooltipDataList, positonToolTip) {

    clearTimeout(this._resizeTimer);
    this._resizeTimer = setTimeout(function() {
      this._resizeWidth = event.target.innerWidth;

      for (let i = 0; i < tooltipObjList.length; i++) {
        positonToolTip(this._resizeWidth, tooltipObjList, tooltipDataList, i);
      }
    }, 250);

  }

  create(data: TooltipData) {

    const screenWidth = window.innerWidth;

    this.tooltipDataList.push(data);

    this._tooltipTimer = setTimeout(() => {
      const tooltip = new Tether({
        element: '.' + data.element,
        target: '.' + data.target,
        attachment: data.position.desktopAttachment,
        targetAttachment: data.position.desktopTargetAttachment
      });

      this.tooltipObjList.push(tooltip);

      this.positonToolTip(screenWidth, this.tooltipObjList, this.tooltipDataList, this.tooltipObjList.length - 1);

      if (!data.sticky) {
        this._tooltipSelfCloseTimer = setTimeout(() => {
          this.closeTooltip(data.id);
        }, data.timer);
      }
    }, 1000);
  }

  closeTooltip(id) {
    for (let i = 0; i < this.tooltipDataList.length; i++) {
      if (this.tooltipDataList[i].id === id) {
        this.tooltipObjList.splice(i, 1);
        this.tooltipDataList.splice(i, 1);
      }
    }
  }

  closeAllTooltips() {
    for (let i = 0; i < this.tooltipDataList.length; i++) {
      this.closeTooltip(this.tooltipDataList[i].id);
    }
  }

  positonToolTip(screenWidth, tooltipObjList, tooltipDataList, index) {

    if (screenWidth < 1100) {

      tooltipObjList[index].setOptions({
        element: '.' + tooltipDataList[index].element,
        target: '.' + tooltipDataList[index].target,
        attachment: tooltipDataList[index].position.mobileAttachment,
        targetAttachment: tooltipDataList[index].position.mobileTargetAttachment
      });
    } else {

      tooltipObjList[index].setOptions({
        element: '.' + tooltipDataList[index].element,
        target: '.' + tooltipDataList[index].target,
        attachment: tooltipDataList[index].position.desktopAttachment,
        targetAttachment: tooltipDataList[index].position.desktopTargetAttachment
      });
    }
  }

  ngOnDestroy() {
    this._removeAllTooltipsSubscription.unsubscribe();
  }

}
